import { getImageUrl } from "helpers";


const TrastedPartners = ({ icon }) => {
    const URL = getImageUrl(icon.image);
    return (
        <div className='trasted-partners-item'>
            <img src={URL} alt="" />
        </div>
    );
}

export default TrastedPartners;